// 초기 화면 크기를 저장할 변수들
let initialScreenWidth = 0;
let initialScreenHeight = 0;
let initialRenderHeight = 0;
let initialRenderWidth = 0;

// 최소 세로 길이 설정
const MIN_RENDER_HEIGHT = 400;
const MIN_RENDER_WIDTH = 228; // 4:7 비율 기준
const MAX_RENDER_HEIGHT = 650; // 최대 세로 길이 제한

// 초기 화면 크기 설정 함수
export const setInitialScreenSize = () => {
  initialScreenWidth = window.innerWidth;
  initialScreenHeight = window.innerHeight;

  // 화면 비율 계산
  const screenRatio = initialScreenWidth / initialScreenHeight;
  const targetRatio = 4 / 7; // 목표 비율 (가로:세로)

  if (screenRatio > targetRatio) {
    // 화면이 더 넓은 경우
    initialRenderHeight = Math.min(initialScreenHeight - 160, MAX_RENDER_HEIGHT); // 상하 여백 80px씩 추가
    initialRenderWidth = initialRenderHeight * targetRatio;
  } else {
    // 화면이 더 좁은 경우
    initialRenderWidth = Math.min(initialScreenWidth - 40, 400);
    initialRenderHeight = initialRenderWidth / targetRatio;
  }

  // 최소 크기 보장
  initialRenderHeight = Math.max(initialRenderHeight, MIN_RENDER_HEIGHT);
  initialRenderWidth = Math.max(initialRenderWidth, MIN_RENDER_WIDTH);
};

export const getRenderHeight = () => {
  // 초기 화면 크기가 설정되지 않았다면 설정
  if (initialScreenWidth === 0) {
    setInitialScreenSize();
  }
  return initialRenderHeight;
};

export const getRenderWidth = () => {
  // 초기 화면 크기가 설정되지 않았다면 설정
  if (initialScreenWidth === 0) {
    setInitialScreenSize();
  }
  return initialRenderWidth;
};